export function isUserGuideOnBreak(user) {
  if (!user) {
    return false;
  }
  return user.guideStatus === 'inactive';
}

export function isTopicGuideOnBreak(sessionInfo) {
  if (!sessionInfo) {
    return false;
  }
  if (sessionInfo.isGuideOnBreak === true) {
    return true;
  }
  return sessionInfo.guideStatus === 'inactive';
}

export function isTopicDetailGuideOnBreak(sessionInfo, user, { isOwnTopic = false, isGuideUser = false } = {}) {
  if (isTopicGuideOnBreak(sessionInfo)) {
    return true;
  }
  if (isOwnTopic && isGuideUser && isUserGuideOnBreak(user)) {
    return true;
  }
  return false;
}
